import { useEffect, useRef, useState } from 'react';
import { useContactLookup } from '@/hooks';
import matterService from '@/services/matter/matterService';
import { useAbility } from '@/providers/';
import { KeenIcon } from '@/components';
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-dt';
import 'datatables.net-select-dt';
import 'datatables.net-responsive-dt';
import { createRoot } from 'react-dom/client';
import { useAuthContext } from '@/auth';
import { useNavigate } from 'react-router-dom';
import { FiltersToFormData, getAccessToken, decodeHtmlEntities } from '@/utils'
import { createDataTableOptions, createDataTableConfig } from '@/utils';
import { SelectInput, DateInput, STATUS_OPTIONS, FilterContainer, ColumnToggleDropdown } from '@/components/TableFilter'
import { cn } from '@/lib/utils';
import invoiceService from '@/services/billing/invoice/invoiceService';
import { goTo403 } from "@/utils/Navigation";
import { Exporter } from '@/components/exporter';

DataTable.use(DT);
const Settlements = ({ dataFromParent, onNavigateFromChild, onClearChildProps }) => {
    console.log('dataFromParent', dataFromParent)
    const { logout } = useAuthContext();
    const [showFilter, setShowFilter] = useState(false);
    const fetchContactLookup = useContactLookup();
    const [filterData, setFilterData] = useState({
        status: null,
        payment_status: null,
        contact_id: dataFromParent?.contactId,
        matter_id: dataFromParent?.matterId,
        from_date: null,
        to_date: null,
        date_range: null,
    });
    const API_URL = import.meta.env.VITE_APP_BASE_URL;
    const token = getAccessToken();
    const tableRef = useRef(null);
    const filterRef = useRef(filterData);
    const Navigate = useNavigate()

    useEffect(() => {
        filterRef.current = filterData;
    }, [filterData]);

    const columns = [
        // {
        //     title: 'S#',
        //     name: 'serial',
        //     data: null,
        //  orderable: true,se,
        //     render: (data, type, row, meta) => meta.row + 1,
        // },
        {
            title: 'Invoices',
            data: 'invoices',
            name: 'invoices',
            orderable: false,
            render: function (data, type, row) {
                console.log('ROW', row)
                return `<div id="invoice-cell-${row.id}"></div>`;
                // return `<span>${row.first_name} ${row.last_name}</span>`;
            }
        },
        {
            title: 'Invoices Total',
            data: 'invoices.total',
            name: 'invoices.total',
            orderable: false,
            // render: function (data, type, row) {
            //     return `$${row.invoices_total}`
            // }
            render: function (data, type, row) {
                return `<div id="invoice-total-cell-${row.id}"></div>`;
            }
        },
        {
            data: 'amount',
            title: 'Settlement amount',
            name: 'amount',
            orderable: true,
            render: function (data, type, row) {
                return `<div>$${row.amount}</div>`;
            }
        },
        {
            data: 'settlement_date',
            title: 'Settlement Date',
            name: 'settlement_date',
            className: '!text-start',
        },
        {
            data: 'created_at',
            title: 'Created At',
            name: 'created_at',
            orderable: true,
        },
        // {
        //     data: 'status',
        //     title: 'Settlement Status',
        //     name: 'status',
        //     render: function (value) {
        //         const badgeClass = value === 'active' ? 'badge-success' : 'badge-danger';
        //         const label = value === 'active' ? 'Active' : 'Inactive';
        //         return `<span className="badge badge-pill badge-outline ${badgeClass} gap-1 items-center">
        //     <span className="badge badge-dot size-1.5 ${badgeClass}"></span>
        //     ${label}
        //   </span>`
        //     }
        // },
    ];

    const defaultVisibleColumns = [
        // 'serial',
        'invoices',
        'invoices.total',
        'amount',
        'date',
        'settlement_date',
        'updated_at',
        'created_at',
        // 'status',
    ];


    const ajaxConfig = createDataTableConfig('/setup/invoices/settlements/data_table_list', filterRef, token, logout);

    const options = createDataTableOptions({
        order: [[4, "desc"]],
        initComplete: function () {
            const api = this.api();
            api.columns().every(function () {
                const col = this;
                const name = col.settings()[0].aoColumns[col.index()].name;
                if (name && !defaultVisibleColumns.includes(name)) {
                    col.visible(false);
                }
            });
        },
        drawCallback: function () {
            const api = this.api();
            const rows = api.rows({ page: 'current' }).data();

            rows.each((row) => {
                const contactContainer = document.getElementById(`contact-cell-${row.id}`);
                if (contactContainer) {
                    if (!contactContainer._reactRoot) {
                        contactContainer._reactRoot = createRoot(contactContainer);
                    }
                    contactContainer._reactRoot.render(renderContactName(row));
                }
                const matterContainer = document.getElementById(`matter-cell-${row.id}`);
                if (matterContainer) {
                    if (!matterContainer._reactRoot) {
                        matterContainer._reactRoot = createRoot(matterContainer);
                    }
                    matterContainer._reactRoot.render(renderMatterName(row));
                }
                const numberContainer = document.getElementById(`number-cell-${row.id}`);
                if (numberContainer) {
                    if (!numberContainer._reactRoot) {
                        numberContainer._reactRoot = createRoot(numberContainer);
                    }
                    numberContainer._reactRoot.render(renderNumber(row));
                }
                const invoiceContainer = document.getElementById(`invoice-cell-${row.id}`);
                if (invoiceContainer) {
                    if (!invoiceContainer._reactRoot) {
                        invoiceContainer._reactRoot = createRoot(invoiceContainer);
                    }
                    invoiceContainer._reactRoot.render(renderInvoiceNumber(row));
                }
                const invoiceTotalContainer = document.getElementById(`invoice-total-cell-${row.id}`);
                if (invoiceTotalContainer) {
                    if (!invoiceTotalContainer._reactRoot) {
                        invoiceTotalContainer._reactRoot = createRoot(invoiceTotalContainer);
                    }
                    invoiceTotalContainer._reactRoot.render(renderInvoiceTotal(row));
                }
            });
        },
    });

    const renderInvoiceTotal = (row) => {
        const { invoices } = row;
        if (!Array.isArray(invoices) || invoices.length === 0) return <span>-</span>;

        // Convert all totals to numbers and sum them
        const mergedTotal = invoices.reduce((sum, group) => {
            const val = Math.round(Number(group.total) * 100); // convert to cents
            return sum + val;
        }, 0);

        return <span>${(mergedTotal / 100).toFixed(2)}</span>;
    };

    const renderInvoiceNumber = (row) => {
        const { invoices, id } = row
        if (!Array.isArray(invoices) || invoices.length === 0) return <span>-</span>;

        return (
            <div className="flex flex-wrap gap-2">
                <span className="cursor-pointer link"
                    onClick={() => {
                        onNavigateFromChild?.(
                            "Invoices",
                            {
                                invoices,
                                // invoice_ids: invoices.map(inv => inv.id),
                                settlement: id,
                            }
                        );
                    }}
                >
                    {invoices.length} {invoices.length === 1 ? 'Invoice' : 'Invoices'}
                </span>
            </div>
        );
    }

    const resetFilters = () => {
        const cleared = {
            status: null,
            contact_id: null,
            matter_id: null,
            from_date: null,
            to_date: null,
            date_range: null,
        };

        setFilterData(cleared);
        filterRef.current = cleared;
        refresh()
        onClearChildProps?.();
    };


    const handleFilterChange = (key, val) => {
        setFilterData(prev => {
            const updated = { ...prev, [key]: val };
            if (key === 'contact_id') updated.matter_id = null; // recommended
            filterRef.current = updated;
            return updated;
        });
    };

    const handleToggleFilter = () => {
        setShowFilter(prev => !prev)
    }

    const fetchLookup = async (type, ctx = {}) => {
        switch (type) {
            case 'contact':
                return await fetchContactLookup();
            case 'matter': {
                const contactId = ctx?.contactId || null;
                if (contactId) {
                    const res = await invoiceService.getContactMatterRelatedData('contact', contactId);
                    const rows = res?.data?.matters || [];
                    return rows.map(m => ({ label: m.name, value: m.id }));
                }
                const matters = await matterService.getAllMatters();
                return (matters?.data || []).map(m => ({ label: m.name, value: m.id }));
            }
            default:
                return [];
        }
    };

    const refresh = () => {
        const table = tableRef.current.dt();
        table.ajax.reload();
    };

    const renderNumber = (row) => {
        const fullNumber = `INVOICE-${row.number}`;
        const { id } = row;
        return (
            <span onClick={() => { handlePreviewInvoice(id) }} className='cursor-pointer link'>{fullNumber}</span>
        )
    }

    const renderContactName = (row) => {
        if (!row.contact) {
            return <span>-</span>;
        }
        const fullName = row.contact.first_name + ' ' + row.contact.last_name;
        const { id } = row.contact;
        return (
            <span onClick={() => { handleNavigateConatct(id) }} className='cursor-pointer link'>{fullName}</span>
        )
    }

    const handleNavigateConatct = (id) => {
        Navigate(`/contacts/${id}/`)
    }

    const handlePreviewInvoice = async (id) => {
        Navigate(`/billing/invoice/preview/${id}`);
    }

    const handleNavigateMatter = (id) => {
        Navigate(`/matters/detail/${id}/`)
    }

    const renderMatterName = (row) => {
        const { matter } = row;
        const fullName = decodeHtmlEntities(matter?.name || '');

        return (
            <span
                onClick={() => handleNavigateMatter(matter?.id || '')}
                className="cursor-pointer link"
            >
                {fullName}
            </span>
        );
    }


    return (
        <>
            {/* Filters */}
            <FilterContainer
                show={showFilter}
                onApply={() => refresh()}
                onReset={resetFilters}
            >
                {/* <SelectInput
                    label="Settlement Status"
                    value={filterData.status}
                    onChange={(val) => handleFilterChange('status', val)}
                    staticOptions={STATUS_OPTIONS}
                    customClass="sm:w-[32%] w-full"
                /> */}

                <DateInput
                    customClass="sm:w-[32%] w-full"
                    label="Created At - (From, To)"
                    mode="range"
                    value={filterData.date_range}
                    onChange={(range) => {
                        setFilterData(prev => ({
                            ...prev,
                            from_date: range?.from ?? null,
                            to_date: range?.to ?? null,
                            date_range: range,
                        }));
                    }}
                />
            </FilterContainer>

            <div className="min-w-full mb-4 card">
                <div className="card-header">
                    <div className='flex items-center gap-1'>
                        <ColumnToggleDropdown tableRef={tableRef} columns={columns} defaultVisibleColumns={defaultVisibleColumns} />
                        <h3 className="card-title">
                            {dataFromParent?.contactName
                                ? `${dataFromParent.contactName} Settlements`
                                : dataFromParent?.matterName
                                    ? `${dataFromParent.matterName} Settlements`
                                    : "All settlement invoices"}
                        </h3>
                    </div>

                    <div className='flex flex-wrap items-center gap-2'>
                        <button className='text-xs btn btn-sm btn-primary btn-outline' onClick={handleToggleFilter}>
                            <KeenIcon icon="filter" className="w-fit btn-icon" />
                            {showFilter ? 'Hide Advanced Filters' : 'Advanced Filters'}
                        </button>
                        <div>
                            <Exporter
                                tableRef={tableRef}
                                module="settlement"
                                // columns={[]}
                                columns={columns}
                                filters={filterData}
                            />
                        </div>
                    </div>
                </div>

                <DataTable
                    id="invoice-table"
                    ajax={ajaxConfig}
                    columns={columns}
                    options={options}
                    ref={tableRef}
                />

            </div>

        </>
    )
}

export { Settlements }
